import React, { useState, useEffect } from "react";
import axios from "axios";
import Config from "./Config/Config";
import Footer from "./Footer";
import Pop_routes from "./Popular-routes";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import toast from "react-hot-toast";

const DeleteAccount = () => {

  const [number, setNumber] = useState("");
  const [otp, setOtp] = useState("");
  const [userId, setUserId] = useState("");

  const [otpSent, setOtpSent] = useState(false);
  const [otpVerified, setOtpVerified] = useState(false);

  const [reason, setReason] = useState("");
  const [remark, setRemark] = useState("");

  const [confirmDelete, setConfirmDelete] = useState(false);

  const [reSendOtpCounter, setResendOtpCounter] = useState(0);
  const [resendStatus, setResendStatus] = useState(false);

  // SEND OTP
  const sendOtp = (e) => {
    e.preventDefault();

    if (number.length !== 10) {
      toast.error("Mobile number must be 10 digits");
      return;
    }

    let payload = { mobile_no: number, };

    axios.post(
      `${Config.API_URL}/api/customer/login`,
      payload,
      {
        headers: { Authorization: `${Config.API_ACCESS_TOKEN}` }
      }
    )
    .then((res) => {

      if (res.data.status) {
        setOtpSent(true);
        setResendOtpCounter(60);
        setResendStatus(true);
        toast.success(res.data.message);
      } else {
        toast.error(res.data.message);
      }

    })
    .catch((err) => {
      toast.error(err?.response?.data?.message || "Server error");
    });
  };


  // RESEND OTP
  const resendOtp = () => {

    let payload = { mobile_no: number };

    axios.post(
      `${Config.API_URL}/api/customer/resendotp`,
      payload,
      {
        headers: { Authorization: `${Config.API_ACCESS_TOKEN}` }
      }
    )
    .then((res) => {

      if (res.data.status) {
        setResendOtpCounter(60);
        setResendStatus(true);
        toast.success(res.data.message);
      }

    })
    .catch(() => {});
  };


  // VERIFY OTP
  const verifyOtp = () => {

    let payload = {
      mobile_no: number,
      otp: otp,
      device_id: null,
      fcm_id: null
    };
  
    axios.post(
      `${Config.API_URL}/api/customer/matchotp`,
      payload,
      {
        headers: { Authorization: `${Config.API_ACCESS_TOKEN}` }
      }
    )
    .then((res) => {
  
      if (!res.data.status) {
        toast.error(res.data.message);
        return;
      }
  
      // ✅ SAVE USER ID
      setUserId(res.data.data._id);
  
      setOtpVerified(true);
      toast.success("OTP Verified");
  
    })
    .catch((err) => {
      toast.error(err?.response?.data?.message || "Something went wrong");
    });
  
  };
  

  // OTP TIMER
  useEffect(() => {

    let interval = setInterval(() => {

      setResendOtpCounter((prev) => {
        if (prev > 0) return prev - 1;
        clearInterval(interval);
        return prev;
      });

    }, 1000);

    return () => clearInterval(interval);

  }, [reSendOtpCounter]);


  useEffect(() => {
    if (reSendOtpCounter === 0) {
      setResendStatus(false);
    }
  }, [reSendOtpCounter]);

  const handleDelete = (e) => {
    e.preventDefault();
  
    if (!otpVerified) {
      toast.error("Please verify OTP first");
      return;
    }
  
    if (!confirmDelete) {
      toast.error("Please confirm account deletion");
      return;
    }
  
    if (!userId) {
        toast.error("User not found");
        return;
      }      
  
    if (reason === "other" && !remark.trim()) {
        toast.error("Please enter remark");
        return;
      }
      const payload = {
        user_id: userId,
        reason: reason === "other" ? remark : reason
      };
      
    axios.post(
      `${Config.API_URL}/api/customer/delete_account`,
      payload,
      {
        headers: {
          Authorization: `${Config.API_ACCESS_TOKEN}`
        }
      }
    )
    .then((res) => {
  
      if (res.data.status) {
  
        toast.success(`${res.data.message || "Account deleted successfully"}`);
  
        // remove login data
        localStorage.removeItem("AccessLogin");
  
        // redirect to home
        window.location.href = "/";
  
      } else {
        toast.error(res.data.message);
      }
  
    })
    .catch((err) => {
      toast.error(err?.response?.data?.message || "Server error");
    });
  
  };
  
  return (
    <>
     <div style={{ backgroundColor: "#fff", minHeight: "100vh" }}>
  <Container className="py-5">


        <Row className="justify-content-center">
          <Col md={10}>

            <div className="p-4 border rounded">

              <h2 className="text-center text-danger mb-4">
                Delete Your Account
              </h2>

              <Form onSubmit={handleDelete}>

                <Row className="mb-4">

                  {/* Phone */}
                  <Col md={4}>
                    <Form.Label>Phone Number *</Form.Label>
                    <Form.Control
                      type="text"
                      value={number}
                      disabled={otpSent}
                      onChange={(e)=>{
                        if (/^\d{0,10}$/.test(e.target.value)) {
                          setNumber(e.target.value);
                        }
                      }}
                      style={{ backgroundColor: "#fff" }}
                    />
                  </Col>

                  {/* Send OTP */}
                  <Col md={2} className="d-flex align-items-end">

                    {!otpSent && (
                      <Button onClick={sendOtp}>
                        Send OTP
                      </Button>
                    )}

                  </Col>

                  {/* OTP */}
                  {otpSent && (
                    <>
                      <Col md={3}>
                        <Form.Label>OTP *</Form.Label>
                        <Form.Control
                          type="text"
                          value={otp}
                          disabled={otpVerified}
                          onChange={(e)=>{
                            if (/^\d{0,4}$/.test(e.target.value)) {
                              setOtp(e.target.value);
                            }
                          }}
                        />
                      </Col>

                      <Col md={3} className="d-flex align-items-end">

                        {!otpVerified ? (
                          <Button
                            variant="success"
                            disabled={otp.length !== 4}
                            onClick={verifyOtp}
                          >
                            Verify OTP
                          </Button>
                        ) : (
                          <span className="text-success fw-bold">
                            Verified ✓
                          </span>
                        )}

                      </Col>
                    </>
                  )}

                </Row>

                {/* RESEND OTP */}
                {otpSent && !otpVerified && (
                  <div className="mb-3">

                    {resendStatus ? (
                      <p>Resend OTP in {reSendOtpCounter}s</p>
                    ) : (
                      <Button variant="link" onClick={resendOtp}>
                        Resend OTP
                      </Button>
                    )}

                  </div>
                )}


                {/* REASON */}

                <Form.Group className="mb-3">
                  <Form.Label>Deletion Reason *</Form.Label>
                  <Form.Select
                    disabled={!otpVerified}
                    value={reason}
                    onChange={(e) => {
                        const value = e.target.value;
                        setReason(value);
                      
                        if (value !== "other") {
                          setRemark("");
                        }
                      }}
                      
                  >
                   <option value="">Select reason</option>
                   <option value="privacy_concerns">Privacy concerns</option>
                   <option value="better_alternative">Found a better alternative service</option>
                   <option value="too_many_notifications">Too many emails / notifications</option>
                   <option value="not_satisfied">Not satisfied with the service</option>
                   <option value="account_created_by_mistake">Account created by mistake</option>
                   <option value="technical_issues">Technical issues / bugs</option>
                   <option value="no_longer_need">No longer need the service</option>
                   <option value="cost_too_high">Cost / Fare is too high</option>
                   <option value="poor_support">Poor customer support experience</option>
                   <option value="temporary_break">Temporary break (will return later)</option>
                   <option value="duplicate_account">Duplicate account</option>
                   <option value="other">Other (please reason specify below)</option>
                  </Form.Select>
                </Form.Group>


                {/* REMARK */}

                {reason === "other" && (
  <Form.Group className="mb-3">
    <Form.Label>Deletion Remark *</Form.Label>
    <Form.Control
      as="textarea"
      rows={3}
      value={remark}
      onChange={(e)=>setRemark(e.target.value)}
      style={{ backgroundColor: "#fff" }}
    />
  </Form.Group>
)}



                {/* WARNING */}

                <div className="p-3 border rounded bg-danger bg-opacity-10 mb-3">

                  <h5 className="text-danger">
                    Are you sure you want to delete your account?
                  </h5>

                  <p>
                    Once you delete your account, there is no going back.
                  </p>

                  <Form.Check
                    type="checkbox"
                    label="I confirm my account deletion"
                    disabled={!otpVerified}
                    checked={confirmDelete}
                    onChange={(e)=>setConfirmDelete(e.target.checked)}
                  />

                </div>


                <Button
                  type="submit"
                  variant="danger"
                  disabled={!confirmDelete}
                >
                  Delete Account
                </Button>

              </Form>

            </div>

          </Col>
        </Row>

      </Container>

      <Pop_routes />
      <Footer />
      </div>
    </>
  );
};

export default DeleteAccount;
